import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";

import {  injectIntl } from "react-intl";


import { TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { updateMaster
  ,getBusinessEntities,getAccounts, getAccountTypes, getProcedureTypes
} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";

import Autocomplete from '@material-ui/lab/Autocomplete';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';


function EditAccount(props) {
  
  console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 // const [user,setUser] =useState({});

  let accountProps = null;
  let expiryDateProps = null;
  if(props.location.data!=null && props.location.data.account!=null && props.location.data.account!=undefined)
  {
    accountProps = props.location.data.account;
    expiryDateProps =props.location.data.account.expiryDate;
  }
 const [account,setAccount] =useState(accountProps);
 const [expiryDate, setExpiryDate] = useState(expiryDateProps);


 const [val,setVal]=useState(false);
const [defaultTypes,setDefaultTypes]=useState(false);

  const [entities,setEntities] =useState({entity:[]});
  
  React.useEffect(() => {
        const fetchEntities = async () => {
            try {
                
                const response = await getBusinessEntities()
                setEntities({entity: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchEntities();
    }, []);

  const [accounts,setAccounts] =useState({account:[]});
  const [mappedAccounts,setMappedAccounts] =useState([]);

  
  
  React.useEffect(() => {
        const fetchAccounts = async () => {
            try {
                
                const response = await getAccounts()
               
                let selectedVal = [];
                let tguser=[];
                //console.log(account.mappedAccounts);
                //console.log(response.data);
                if(account.mappedAccounts!==null)
                {
                response.data.map((acc,i)=>
                          (
                            //console.log("data1",acc.accountId,i),
                              account.mappedAccounts.filter(a=> a === acc.accountId).map((mp)=>(
                                selectedVal.push(response.data[i]),
                                tguser.push(acc.accountId)
                              ))
                          ))
                setVal(selectedVal);
                console.log("data",selectedVal);
                setMappedAccounts(tguser);
                }
                
                setAccounts({account: response.data});
                
                
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchAccounts();
    }, []);


const [procedureTypes,setProcedureTypes] =useState({procedureType:[]});

const [mappedProcedureTypes,setMappedProcedureTypes] =useState([]);
  React.useEffect(() => {
        const fetchProcedureTypes = async () => {
            try {
                
                const response = await getProcedureTypes()
               
                let selectedVal = [];
                let tguser=[];
                //console.log(account.mappedAccounts);
                //console.log(response.data);
                if(account.procedureTypes!==null)
                {
                response.data.map((pt,i)=>
                          (
                            //console.log("data1",acc.accountId,i),
                              account.procedureTypes.filter(a=> a === pt.procedureTypeKey).map((mp)=>(
                                selectedVal.push(response.data[i]),
                                tguser.push(pt.procedureTypeKey)
                              ))
                          ))
                setDefaultTypes(selectedVal);
                console.log("data ppp",selectedVal);
                setMappedProcedureTypes(tguser);
                }
                console.log("procedureType::::",response.data)
                setProcedureTypes({procedureType:response.data});
                
                
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchProcedureTypes();
    }, []);

const [accountTypes,setAccountTypes] =useState({accountType:[]});

  React.useEffect(() => {
        const fetchAccountTypes = async () => {
            try {
                
                const response = await getAccountTypes()
                setAccountTypes({accountType: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchAccountTypes();
    }, []);

   

  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };

const onSelectTag=(e, value)=> {

let tguser=[];
let selectedVal=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.accountId),
      selectedVal.push(acc)
      ))
    console.log(tguser);
    setDefaultTypes(selectedVal);
    setMappedAccounts(tguser);
  }
}

const onSelectType=(e, value)=> {

let tguser=[];
let selectedVal=[];
console.log("valy:::::",value);
  if(value!==undefined && value!==null)
  {
    value.map((acc)=>(
      tguser.push(acc.procedureTypeKey),
      selectedVal.push(acc)
      ))
    console.log("procedureTypeaaaa::",tguser);
    setVal(selectedVal);
    setMappedProcedureTypes(tguser);
  }
}

const onDateChange=(e, value)=> {


    setExpiryDate(value);
  
}


  return (
    <>
      {account!==null &&
      <Formik
                  initialValues={{
                    accountName: account.accountName,
                    businessEntity: account.businessEntity,
                    mappedAccounts: val,
                    colorCode:account.colorCode,
                    accountTypeKey:account.accountTypeKey,
                    expiryDate:account.expiryDate,
                   
                  }}
                  validate={values => {
                    const errors = {};

                    
                    if (!values.accountName) {
                      errors.accountName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.businessEntity) {
                      errors.businessEntity = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    /*
                    if (!values.accountTypeKey) {
                      errors.accountTypeKey = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }*/

                    
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                    enableLoading();

                    let data  = {
                      'accountName' : values.accountName,
                      'businessEntity': values.businessEntity,
                      'mappedAccounts' : mappedAccounts,
                      'expiryDate' : expiryDate,
                      'colorCode' : values.colorCode,
                      'accountTypeKey' : values.accountTypeKey,
                      'procedureTypes' : mappedProcedureTypes
                    }


                    updateMaster('account',account.accountId,data)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        disableLoading();
                        setStatus(
                          intl.formatMessage({
                            id: "CREATION.SUCCESS.MESSAGE"
                          })
                        );
                        setStatusColor('alert-success');
                        window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">


                  <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Account Name"
                          className="kt-width-full"
                          name="accountName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.accountName}
                          helperText={touched.accountName && errors.accountName}
                          error={Boolean(touched.accountName && errors.accountName)}
                        />
                      </div>    
              

                      <div className="form-group mb-0">

                    <TextField  style={{'width':'100%'}} name="businessEntity" onBlur={handleBlur}
                        id="businessEntity" onChange={handleChange} label="Business Entity"
                         value={values.businessEntity}
                          helperText={touched.businessEntity && errors.businessEntity}
                          error={Boolean(touched.businessEntity && errors.businessEntity)}
                          select>
                        {
                         entities.entity.map((ent) => (
                           <MenuItem key={ent.businessEntity} value={ent.businessEntity}>{ent.description}</MenuItem>
                        ))
                        }
                    </TextField>

                     
                            
                      </div>
                      <div className="form-group mb-0">

                    <TextField  style={{'width':'100%'}} name="accountTypeKey" onBlur={handleBlur}
                        id="businessEntity" onChange={handleChange} label="Account Type"
                         value={values.accountTypeKey}
                          helperText={touched.accountTypeKey && errors.accountTypeKey}
                          error={Boolean(touched.accountTypeKey && errors.accountTypeKey)}
                          select>
                        {
                         accountTypes.accountType.map((typ) => (
                           <MenuItem key={typ.accountTypeKey} value={typ.accountTypeKey}>{typ.accountTypeName}</MenuItem>
                        ))
                        }
                    </TextField>

                     
                            
                      </div>

                      {/*<div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Color Code"
                          className="kt-width-full"
                          name="colorCode"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.colorCode}
                          helperText={touched.colorCode && errors.colorCode}
                          error={Boolean(touched.colorCode && errors.colorCode)}
                        />
                      </div> */} 

                      <div className="form-group mb-0">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="expiryDate"
                              name="expiryDate"
                              label="Expiry Date"
                              value={expiryDate}
                              onChange={onDateChange}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>
                      
                      <div className="form-group mb-0">
                      {val !==false &&
                      <Autocomplete
                      defaultValue={val}
                        multiple
                        id="tags-standard"
                        options={accounts.account}
                        onChange={onSelectTag}
                        getOptionLabel={(option) => option.accountName + ' (' + option.businessEntity + ')'}
                        renderInput={(params) => (
                                  <TextField
                                  {...params}
                          
                                                            margin="normal"
                                                            label="Map Accounts"
                                                            
                                                          />

                        )}
                      />
                    }
                    {val ===false &&
                      <Autocomplete
                      multiple
                      id="tags-standard"
                      options={accounts.account}
                      onChange={onSelectTag}
                      getOptionLabel={(option) => option.accountName + ' (' + option.businessEntity + ')'}
                      renderInput={(params) => (
                                <TextField
                                {...params}
                        
                                                          margin="normal"
                                                          label="Map Accounts"
                                                          
                                                        />

                      )}
                    />
    }
                                    </div>
                      
                                  
                                
                                     <div className="form-group mb-0">
                                        { defaultTypes !==false &&
                                         <Autocomplete
                                        defaultValue={defaultTypes}
                                        multiple
                                        id="p-standard"
                                        options={procedureTypes.procedureType}
                                        onChange={onSelectType}
                                        getOptionLabel={(option) => option.procedureTypeName}
                                        renderInput={(params) => (
                                                  <TextField
                                                  {...params}
                                          
                                                                            margin="normal"
                                                                            label="Procedure Types"
                                                                            
                                                                          />

                                        )}
                                      />
                                        }
                                        { defaultTypes ===false &&
                                        <Autocomplete
                                         
                                          multiple
                                          id="p-standard"
                                          options={procedureTypes.procedureType}
                                          onChange={onSelectType}
                                          getOptionLabel={(option) => option.procedureTypeName}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              margin="normal"
                                              label="Procedure Types"
                                            />

                                          )}
                                        />
                                        }
   
                                    </div>
                  
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Update
                        </button>
                      </div>
        </form>
         )}
                </Formik>
              }
                </>
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(EditAccount)
);
